import { ListItem, Menu } from '@material-ui/core';
import styled from 'styled-components';
import { IconSize } from '../../lib';
export const StyledListItem = styled(ListItem) `
    display: flex;
    align-items: center;
    color: ${(props) => props.theme.colors.primary} !important;
    cursor: pointer;

    svg {
        width: ${IconSize.Small};
        margin-right: 1rem;
    }
`;
export const StyledMenu = styled(Menu) `
    .MuiPaper-root {
        background-color: ${(props) => props.theme.colors.floatingSurface};
    }
`;
//# sourceMappingURL=index.styles.js.map